import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Dropdown from "../../../../controls/Dropdown";
import BackEnd from "../../../../backend/BackEnd";
import PlainDropdown from "../../../../controls/PlainDropdown";

class CompanyProductRow extends Component {
    static propTypes = {
        data: PropTypes.object.isRequired,
        taxTypes: PropTypes.array.isRequired,
        onUpdate: PropTypes.func.isRequired,
        onRemove: PropTypes.func.isRequired
    };
    static defaultProps = {};
    state = {
        product: this.props.data.product,
        productId: this.props.data.productId,
        productText: (this.props.data.product || {}).fullName || '',
        count: this.props.data.count,
        desiredPrice: this.props.data.desiredPrice,
        desiredPriceTypeId: this.props.data.desiredPriceTypeId || this.props.taxTypes[0].id,
        agreedPrice: this.props.data.agreedPrice,
        agreedPriceTypeId: this.props.data.agreedPriceTypeId || this.props.taxTypes[0].id,
        comment: this.props.data.comment,
    };

    render() {
        const {onRemove, taxTypes} = this.props;
        return (
            <tr>
                <td>
                    <Dropdown dataSource={new BackEnd.CompaniesAdmin.SearchProducts()}
                              item={this.state.product ? {id: this.state.product.id, text: this.state.product.code} : null}
                              templateSelection={item => item.code || item.text}
                              onChange={(event, data) => this.updateState({
                                  productId: event.target.value,
                                  productText: data[0].fullName
                              })}/>
                </td>
                <td>
                    {this.state.productText}
                </td>
                <td>
                    <input type="number" className="form-control"
                           placeholder="Мощность"
                           min="0"
                           value={this.state.count}
                           onChange={event => this.updateState({count: event.target.value})}/>
                </td>
                <td>
                    <input type="number" className="form-control"
                           placeholder="Желаемая цена"
                           min="0"
                           value={this.state.desiredPrice}
                           onChange={event => this.updateState({desiredPrice: event.target.value})}/>
                </td>
                <td>
                    <PlainDropdown className="form-control"
                                   placeholder="Условия оплаты"
                                   items={taxTypes}
                                   value={this.state.desiredPriceTypeId}
                                   onChange={event => this.updateState({desiredPriceTypeId: event.target.value})}/>
                </td>
                <td>
                    <input type="number" className="form-control"
                           placeholder="Согласованная цена"
                           min="0"
                           value={this.state.agreedPrice}
                           onChange={event => this.updateState({agreedPrice: event.target.value})}/>
                </td>
                <td>
                    <PlainDropdown className="form-control"
                                   placeholder="Условия оплаты"
                                   items={taxTypes}
                                   value={this.state.agreedPriceTypeId}
                                   onChange={event => this.updateState({agreedPriceTypeId: event.target.value})}/>
                </td>
                <td>
                    <textarea className="form-control" rows="3"
                              style={{resize: 'none'}}
                              value={this.state.comment}
                              onChange={event => this.updateState({comment: event.target.value})}/>
                </td>
                <td>
                    <button type="button" className="btn btn default btn-outline"
                            onClick={() => onRemove()}>
                        <i className="fa fa-close"/>
                    </button>
                </td>
            </tr>
        );
    }

    updateState(state) {
        const {onUpdate} = this.props;

        this.setState(state, () => onUpdate(this.state));
    }
}

export default CompanyProductRow;


// WEBPACK FOOTER //
// ./src/pages/Catalogs/Companies/components/CompanyProductRow.js